import { MortgageCalculation, MortgageDetail } from '@ap/ap-interface-apix-hypotheken-berekening';
import { Money } from '@ap/interface-bspc-core';

export class MortgageCalculationBuilder {
    private maxMortgage: Money;
    private maxMortgageByIncome: MortgageDetail;
    private maxMortgageByProperty: MortgageDetail;
    private expectedMortgage: MortgageDetail;
    private asset: Money;

    withMaxMortgage(maxMortgage: Money): this {
        this.maxMortgage = maxMortgage;
        return this;
    }

    withMaxMortgageByIncome(maxMortgageByIncome: MortgageDetail): this {
        this.maxMortgageByIncome = maxMortgageByIncome;
        return this;
    }

    withExpectedMortgage(expectedMortgage: MortgageDetail): this {
        this.expectedMortgage = expectedMortgage;
        return this;
    }

    withMaxMortgageByProperty(maxMortgageByProperty: MortgageDetail): this {
        this.maxMortgageByProperty = maxMortgageByProperty;
        return this;
    }

    withAsset(asset: Money): this {
        this.asset = asset;
        return this;
    }

    build(): MortgageCalculation {
        return {
            max_mortgage: this.maxMortgage,
            max_mortgage_by_income: this.maxMortgageByIncome,
            expected_mortgage: this.expectedMortgage,
            max_mortgage_by_property: this.maxMortgageByProperty,
            asset: this.asset
        } as MortgageCalculation;
    }
}

export const aMortgageCalculation = new MortgageCalculationBuilder();
